import React from 'react';
import './Home.css';
import Portfolio from "./OurTeam"; 
import Contact from "./Contact";
import PracticeArea from './PracticeArea';

function Home() {
  return (
    <div className="home-container">

      {/* Banner Section */}
      <div className="home-banner">
  <img src="image1.jpg" alt="Banner" className="banner-image" />
  <div className="banner-text-overlay">
    <h1>ALLIANCE LAW GROUP</h1>
    <p>Client-Centric. Performance-Driven. Legally Strong.</p>
  </div>
</div>

      {/* About Us Section */}
<div className="about-container">
  <div className="about-heading">
    <h2>ABOUT <br />US</h2>
  </div>
  <div className="about-text">
    <p>
    ALLIANCE LAW GROUP (ALG), established in 2012 by Yash Mishra, stands as a distinguished multi-disciplinary litigation firm committed to delivering client-centric and performance-driven legal solutions. The firm's ethos is rooted in a profound understanding of the complexities inherent within the legal landscape, coupled with an unwavering dedication to achieving best outcomes for its clientele. ALG's operational philosophy emphasizes a proactive and diligent approach, ensuring that each case is handled with meticulous attention to detail and strategic foresight.

    </p>
    <p>
    ALG distinguishes itself through the composition of its highly active and industrious team of legal professionals. These individuals are characterized by their unwavering commitment to continuous professional development, ensuring they remain abreast of the evolving legal world.
    </p>
    <p>
    The firm's multi-disciplinary expertise encompasses a broad spectrum of legal domains, including but not limited to company law, environmental law, contract law, arbitration, insurance law, civil law, criminal law, family law, and aviation law. This comprehensive suite of services enables ALG to address the diverse and intricate legal needs of its clients, providing holistic and bespoke solutions tailored to individual circumstances. By maintaining a robust pan-Indian presence, ALG ensures accessibility and comprehensive legal representation across the Republic of India.
    </p>
  </div>
</div>


      {/* Our Team Section */}
      <section id="ourteam">
        <Portfolio />
      </section>

      {/* Practice Areas Section */}
      <section id="practice">
        <PracticeArea />
      </section>

      {/* Contact Section */}
      <section id="contact">
        <Contact />
      </section>
    </div>
  );
}

export default Home;
